
// ==========================================
// 3. src/components/layout/Navigation.js
// ==========================================
import React, { useState } from 'react';
import { X, Menu } from 'lucide-react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: '#problem', label: 'Problem' },
    { href: '#solution', label: 'Solution' },
    { href: '#standards', label: 'Standards' },
    { href: '#how', label: 'How It Works' },
    { href: '#about', label: 'About' },    
    { href: '#team', label: 'Team' },    
    { href: '#vision', label: 'Vision' }   
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-100 backdrop-blur-lg bg-white/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              SYBR ®
            </span>
            <span className="ml-3 text-sm text-gray-500 hidden sm:inline">
              Software Your Business Remembers
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-gray-700 hover:text-blue-600 transition"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://calendly.com/sybrtms/intro-call"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition font-semibold"
            >
              Book a Demo
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-100">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="block px-3 py-2 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://calendly.com/sybrtms/intro-call"
              className="block px-3 py-2 bg-blue-600 text-white rounded-lg text-center"
            >
              Book a Demo
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;